/* ============================================================================
   Golden Hasat — ui.js
   Globale UI-Verhalten (defer, läuft VOR theme.js).
   → window.GoldenHasat NIE cachen; live bei Klick lesen: GH().
   ========================================================================== */
(function () {
  "use strict";
  const GH = () => window.GoldenHasat || {};
  // Übersetzte UI-Texte aus layout/theme.liquid (window.GH_T); Fallback Deutsch
  const L = (key, fallback) => (window.GH_T && window.GH_T[key]) || fallback;
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  document.addEventListener("DOMContentLoaded", () => {
    /* ---- Mobile-Nav ---- */
    const nav = document.querySelector(".mobile-nav");
    const overlay = document.querySelector("[data-drawer-overlay]");
    document.querySelectorAll("[data-open-nav]").forEach((b) =>
      b.addEventListener("click", () => {
        nav?.classList.add("is-open");
        overlay?.classList.add("is-open");
        document.body.style.overflow = "hidden";
      })
    );
    document.querySelectorAll("[data-close-nav]").forEach((b) =>
      b.addEventListener("click", () => {
        nav?.classList.remove("is-open");
        overlay?.classList.remove("is-open");
        document.body.style.overflow = "";
      })
    );

    /* ---- Overlay schließt alles ---- */
    overlay?.addEventListener("click", () => {
      nav?.classList.remove("is-open");
      overlay.classList.remove("is-open");
      GH().closeDrawer?.();
      document.body.style.overflow = "";
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        nav?.classList.remove("is-open");
        overlay?.classList.remove("is-open");
        GH().closeDrawer?.();
        document.body.style.overflow = "";
      }
    });

    /* ---- Cart-Drawer öffnen ---- */
    document.querySelectorAll("[data-open-cart]").forEach((b) =>
      b.addEventListener("click", (e) => {
        e.preventDefault();
        GH().openDrawer?.();
      })
    );
    document.querySelectorAll("[data-close-cart]").forEach((b) =>
      b.addEventListener("click", () => GH().closeDrawer?.())
    );

    /* ---- Add-to-Cart (Produktkarten + PDP) ---- */
    document.addEventListener("click", async (e) => {
      const btn = e.target.closest("[data-add-to-cart]");
      if (!btn) return;
      e.preventDefault();
      const id = btn.dataset.variantId;
      if (!id) return;
      const qtyEl = btn.closest("form")?.querySelector("[data-qty-input]");
      const quantity = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = L("adding", "Wird hinzugefügt …");
      try {
        await GH().addToCart({ id: Number(id), quantity });
        await GH().refreshDrawer?.();
        GH().toast?.(L("added", "Zum Warenkorb hinzugefügt"));
        GH().openDrawer?.();
      } catch (err) {
        GH().toast?.(err.message || L("error", "Fehler"), { icon: false });
      } finally {
        btn.disabled = false;
        btn.textContent = original;
      }
    });

    /* ---- Menge Stepper (generisch) ---- */
    document.addEventListener("click", (e) => {
      const dec = e.target.closest("[data-qty-dec]");
      const inc = e.target.closest("[data-qty-inc]");
      if (!dec && !inc) return;
      const wrap = (dec || inc).closest(".qty");
      const input = wrap?.querySelector("[data-qty-input]");
      if (!input) return;
      let v = parseInt(input.value, 10) || 1;
      v = inc ? v + 1 : Math.max(1, v - 1);
      input.value = v;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    /* ---- Accordion ---- */
    document.querySelectorAll(".accordion__trigger").forEach((t) =>
      t.addEventListener("click", () => {
        const expanded = t.getAttribute("aria-expanded") === "true";
        t.setAttribute("aria-expanded", String(!expanded));
        const panel = t.nextElementSibling;
        panel.style.maxHeight = expanded ? "0" : panel.scrollHeight + "px";
      })
    );

    /* ---- Reveal on scroll ---- */
    const reveals = document.querySelectorAll(".reveal");
    if (reveals.length && "IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries) => entries.forEach((en) => {
          if (en.isIntersecting) { en.target.classList.add("is-visible"); io.unobserve(en.target); }
        }),
        { threshold: 0.12 }
      );
      reveals.forEach((r) => io.observe(r));
    } else {
      reveals.forEach((r) => r.classList.add("is-visible"));
    }

    /* ---- Sticky mobile CTA (PDP) ---- */
    const sticky = document.querySelector(".sticky-mobile-cta");
    const buyBox = document.querySelector(".pdp__buy");
    if (sticky && buyBox && "IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries) => entries.forEach((en) => sticky.classList.toggle("is-visible", !en.isIntersecting)),
        { threshold: 0 }
      );
      io.observe(buyBox);
    }

    /* ---- Mobile Filter-Panel toggle ---- */
    document.querySelectorAll("[data-toggle-filters]").forEach((b) =>
      b.addEventListener("click", () => {
        document.querySelector(".filter-panel")?.classList.toggle("is-open");
      })
    );

    /* ---- Wunschliste (localStorage) ---- */
    const WKEY = "gh_wishlist";
    const wlGet = () => { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } };
    const wlSet = (a) => { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} };

    function wlRefresh() {
      const list = wlGet();
      document.querySelectorAll("[data-wishlist-count]").forEach((el) => {
        el.textContent = list.length;
        el.hidden = list.length === 0;
      });
      document.querySelectorAll("[data-wishlist-toggle]").forEach((btn) => {
        const on = list.includes(btn.dataset.handle);
        btn.classList.toggle("is-active", on);
        const lbl = btn.querySelector("[data-wishlist-label]");
        if (lbl) lbl.textContent = on ? L("wishlistOn", "Auf der Wunschliste ✓") : L("wishlistAdd", "Auf die Wunschliste");
      });
    }

    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-wishlist-toggle]");
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const h = btn.dataset.handle;
      let list = wlGet();
      if (list.includes(h)) { list = list.filter((x) => x !== h); }
      else { list.push(h); GH().toast?.(L("wishlistAdded", "Zur Wunschliste hinzugefügt")); }
      wlSet(list);
      wlRefresh();
      document.dispatchEvent(new CustomEvent("wishlist:updated", { detail: list }));
    });
    wlRefresh();

    /* ---- Mobile: Kategorien-Untermenü aufklappen ---- */
    document.querySelectorAll("[data-mobile-sub-toggle]").forEach((btn) =>
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const expanded = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", String(!expanded));
        const sub = btn.closest(".mobile-nav__group")?.querySelector("[data-mobile-sub]");
        sub?.classList.toggle("is-open", !expanded);
      })
    );

    /* ---- Cart-Drawer: Menge ändern / entfernen ---- */
    const drawerBody = document.querySelector("[data-cart-body]");
    if (drawerBody) {
      drawerBody.addEventListener("click", async (e) => {
        const inc = e.target.closest("[data-line-inc]");
        const dec = e.target.closest("[data-line-dec]");
        const rem = e.target.closest("[data-line-remove]");
        if (!inc && !dec && !rem) return;
        const row = e.target.closest("[data-line-key]");
        const key = row?.dataset.lineKey;
        if (!key) return;
        let qty = 0;
        if (rem) {
          qty = 0;
        } else {
          const cur = parseInt(row.querySelector("[data-line-qty]")?.textContent, 10) || 1;
          qty = inc ? cur + 1 : Math.max(0, cur - 1);
        }
        try {
          await GH().changeLine(key, qty);
          const cart = await GH().refreshDrawer();
          renderDrawer(cart);
        } catch (err) {
          GH().toast?.("Aktualisierung fehlgeschlagen", { icon: false });
        }
      });
    }

    /* ---- Freeship-Bar + Zeilen neu rendern ---- */
    function money(cents) { return GH().money ? GH().money(cents) : (cents / 100).toFixed(2) + " €"; }

    function renderDrawer(cart) {
      const body = document.querySelector("[data-cart-body]");
      const foot = document.querySelector("[data-cart-foot]");
      if (!body) return;
      if (cart.item_count === 0) {
        body.innerHTML =
          `<div class="empty-state"><h2>${L("cartEmptyTitle", "Dein Warenkorb ist leer")}</h2><p>${L("cartEmptyText", "Entdecke ausgewählte Schätze der Natur.")}</p><a href="${ROOT}collections/all" class="btn btn--primary" data-close-cart>${L("browse", "Jetzt stöbern")}</a></div>`;
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;
      body.innerHTML = cart.items.map((item) => `
        <div class="cart-line" data-line-key="${item.key}">
          <a href="${item.url}" class="cart-line__img">${item.image ? `<img src="${item.image.replace(/(\.[a-z]+)(\?|$)/i, "_150x$1$2")}" alt="" width="72" height="72">` : ""}</a>
          <div>
            <a href="${item.url}"><div class="cart-line__title">${item.product_title}</div></a>
            ${item.variant_title && item.variant_title !== "Default Title" ? `<div class="cart-line__variant">${item.variant_title}</div>` : ""}
            <div class="cart-line__qty" data-line-key="${item.key}">
              <button data-line-dec aria-label="${L("decrease", "Weniger")}"><span class="icon icon--sm"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 12h14"/></svg></span></button>
              <span data-line-qty>${item.quantity}</span>
              <button data-line-inc aria-label="${L("increase", "Mehr")}"><span class="icon icon--sm"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></span></button>
            </div>
          </div>
          <div>
            <div class="cart-line__price">${money(item.final_line_price)}</div>
            <button class="cart-line__remove" data-line-remove data-line-key="${item.key}">${L("remove", "Entfernen")}</button>
          </div>
        </div>`).join("");

      const sub = document.querySelector("[data-cart-subtotal]");
      if (sub) sub.textContent = money(cart.total_price);
      updateFreeship(cart.total_price);
    }

    function updateFreeship(total) {
      const bar = document.querySelector("[data-freeship]");
      if (!bar) return;
      const threshold = parseInt(bar.dataset.threshold, 10) || (window.GH_CONFIG?.freeShippingThreshold ?? 4900);
      const fill = bar.querySelector("[data-freeship-fill]");
      const pct = Math.min(100, (total / threshold) * 100);
      if (fill) fill.style.width = pct + "%";
      const label = bar.querySelector(".free-ship-bar__label");
      if (label) {
        label.innerHTML = total >= threshold
          ? L("freeshipDone", "<strong>Geschafft!</strong> Du erhältst kostenlosen Versand. 🌿")
          : L("freeshipRest", "Noch <strong>__AMOUNT__</strong> bis zum kostenlosen Versand").replace("__AMOUNT__", money(threshold - total));
      }
    }

    document.addEventListener("cart:updated", (e) => renderDrawer(e.detail));
  });
})();
